import { MUI_MODAL_Z_INDEX } from '@asset/enum/common';
import { Button } from '@components/amc/Button';
import LoadingScreen from '@components/common/loading/LoadingScreen';
import { IconReload } from '@tabler/icons-react';
import { useChatStore } from '@store/chat';
import _ from 'lodash';
import React, { useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const QuestionChatDetailModal = () => {
  const {
    questionDetailUrl,
    setQuestionDetailUrl
  } = useChatStore();
  const [loadSuccessQuestionDetail, setLoadSuccessQuestionDetail] = useState(false);
  const [questionDetailModalKey, setQuestionDetailModalKey] = useState(0);
  const closeIframeModal = () => {
    setQuestionDetailUrl(null);
    setLoadSuccessQuestionDetail(false);
  };
  if (!_.isNil(questionDetailUrl)) return /*#__PURE__*/_jsx("div", {
    className: "fixed top-0 left-0 modal",
    style: {
      zIndex: MUI_MODAL_Z_INDEX
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col modal-content w-[100dvw] h-[100dvh]",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-between px-3 py-1 bg-my-gray-30",
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex items-center gap-3",
          children: /*#__PURE__*/_jsx("div", {
            className: "cursor-pointer text-label-lg-500 text-my-gray-100",
            onClick: closeIframeModal,
            children: "\uB2EB\uAE30"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "flex items-center",
          children: /*#__PURE__*/_jsx(Button, {
            variant: "Ghost",
            icon: /*#__PURE__*/_jsx(IconReload, {}),
            size: "Medium",
            className: "hover:!bg-zinc-700 active:!bg-zinc-700 [&_svg]:!stroke-[var(--gray-100)]",
            onClick: () => {
              setLoadSuccessQuestionDetail(false);
              setQuestionDetailModalKey(prev => prev + 1);
            }
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "relative flex-grow w-full bg-my-gray-100",
        children: [/*#__PURE__*/_jsx("iframe", {
          src: questionDetailUrl,
          onLoad: () => setLoadSuccessQuestionDetail(true),
          className: "w-full h-full"
        }, questionDetailModalKey), !loadSuccessQuestionDetail && /*#__PURE__*/_jsx(LoadingScreen, {})]
      })]
    })
  });
};
export default QuestionChatDetailModal;